// work data

export const Work = [
    {
        id:1,
        name:"Client's Portfolio Page",
        description:"It is build on top of the vue JS, with styledComponents and nuxtjs.",
        tags:["nuxtjs","vue","styledComponents"],
        
        demo:"https://nallaiyasamy-portfolio.netlify.app/",
        github:"https://github.com/tpoornashree/client2-portfolio-using-vueandnuxtjs"
    },
    {
        id:2,
        name:"Launch countdown timer",
        description:"a launch countdown timer that ticks down every second",
        tags:["javascript","html"],
        
        demo:"https://tpoornashree.github.io/Launch-countdown-timer-main-main/",
        github:"https://github.com/tpoornashree/Launch-countdown-timer-main-main"
        
    },
    {
        id:3,
        name:"Voting website",
        description:"building a voting website that declares the winner after reaching a specified no. of votes.",
        tags:["javascript","html","css"],
        
        demo:"https://tpoornashree.github.io/vote-wisely/",
        github:"https://github.com/tpoornashree/vote-wisely"
    },
    {
        id:4,
        name:"Google-UI clone",
        description:"A cool looking google ui clone.",
        tags:["css","html","javascript"],
        
        demo:"https://tpoornashree.github.io/searching-made-easier-google-clone/",
        github:"https://github.com/tpoornashree/searching-made-easier-google-clone"
       
    },{
        id:5,
        name:"Searching for github users",
        description:"to find a github user of your choice",
        tags:["HTML","javascript","API"],
        
        demo:"https://github.com/tpoornashree/finding-github-users",
        github:"https://github.com/tpoornashree/finding-github-users"
        
    },
    {
        id:6,
        name:"Client's portfolio using reactjs and sanity.io for backend.",
        description:"A reponsive portfolio page in ReactJS with react-router functionalities.",
        tags:["react","react-router","css"],
        
        demo:"https://sm-balajiii-portfolio.netlify.app//",
        github:"https://github.com/tpoornashree/client-portfolio.github.io"
        
    },
    
  
] 